// Presentation of the existing /challenge/daily/me contract. No eligibility writes.
export function challengeBannerEntry(mine) {
  const entries = (mine?.entries || []).filter(entry => typeof entry?.title === 'string' && entry.title.trim() && Number.isFinite(entry.listeners_today) && entry.listeners_today >= 0);
  if (!entries.length) return { state: 'none' };
  const target = mine.min_song_listeners;
  const entry = [...entries].sort((a, b) => b.listeners_today - a.listeners_today)[0];
  const remaining = Number.isFinite(target) && target > 0 ? Math.max(0, target - entry.listeners_today) : undefined;
  return { state: remaining === 0 ? 'qualified' : 'entered', title: entry.title, remaining };
}
